import { render, staticRenderFns } from "./DataInvoiceItem.vue?vue&type=template&id=d239cd84&scoped=true"
import script from "./DataInvoiceItem.vue?vue&type=script&lang=js"
export * from "./DataInvoiceItem.vue?vue&type=script&lang=js"
import style0 from "./DataInvoiceItem.vue?vue&type=style&index=0&id=d239cd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d239cd84",
  null
  
)

export default component.exports